import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Container from '../../../components/dashboard/container';
import { isAeroAdmin } from '../../../components/access';
import { withAuthorization } from '../../../model/Session';
import CompetitionForm from './competitionForm';
import * as ROUTES from '../../../constants/routes';
import { FirebasePropType, withFirebase } from '../../../model/Firebase';
import Fields from './fields';
import Loading from '../../../components/loading';

const EditCompetition = ({ firebase, match, history }) => {
  const [competition, setCompetition] = React.useState(Fields.defaultValues());
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    const { id } = match.params;
    let unsubscribe;
    if (id) {
      unsubscribe = firebase.competition(id)
        .onSnapshot((doc) => {
          const codCompetition = Fields.getInstance(doc);
          setCompetition(codCompetition);
          setLoading(false);
        }, () => history.push(ROUTES.COMPETENCIAS));
    } else {
      history.push(ROUTES.COMPETENCIAS);
    }
    return () => !!unsubscribe && unsubscribe();
  }, [firebase, history, match.params]);

  return (
    <Container
      backPath={ROUTES.COMPETENCIAS}
      title={`Competencia: ${competition.name}`}
    >
      <Grid container spacing={3} justify="center">
        <Grid item xs={12} md={6}>
          {loading ? (
            <Loading />
          ) : (
            <CompetitionForm isNew={false} defaultValues={competition} />
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

EditCompetition.propTypes = {
  firebase: FirebasePropType.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default compose(
  withAuthorization(isAeroAdmin),
  withFirebase,
  withRouter,
)(EditCompetition);
